import { reverse } from 'named-urls'
import React from 'react'
import { useNavigate } from 'react-router-dom'

import { Icon, useMediaQueryContext } from '@fourthwall/components'
import { CopyIcon, PencilIcon, PreviewOffIcon, TrashIcon } from '@fourthwall/icons'

import { routing } from '../../../../../../utils/routing'
import { useBottomSheetContext } from '../../../../components/BottomSheet'
import { useDuplicateSection } from '../../../../hooks/useDuplicateSection'
import { useRemoveSection } from '../../../../hooks/useRemoveSection'
import { useSectionVisibility } from '../../../../hooks/useSectionVisibility'
import { useThemeEditorContext } from '../../../../hooks/useThemeEditorContext'
import { usePageLayoutContext } from '../../../../providers/PageLayoutProvider'
import { useThemeLivePreviewContext } from '../../providers/ThemeLivePreviewProvider'
import * as S from './styled'

export const InspectorToolbar = () => {
  const media = useMediaQueryContext()
  const { rect, activeSectionName, activeSectionKey } = useThemeLivePreviewContext()
  const navigate = useNavigate()
  const { currentPageId } = useThemeEditorContext()
  const { pageLayoutQuery } = usePageLayoutContext()
  const { removeSection } = useRemoveSection()
  const { changeSectionVisibility } = useSectionVisibility()
  const { triggerBounce: triggerBottomSheetBounce } = useBottomSheetContext()
  const { duplicateSection } = useDuplicateSection()

  const section = pageLayoutQuery.data?.sectionsGroups
    .flatMap((group) => group.sections)
    .find((section) => section.sectionKey === activeSectionKey)

  if (!activeSectionName) return null

  const redirectToSection = () => {
    if (!activeSectionKey) return

    !media.laptop && triggerBottomSheetBounce()
    navigate(
      reverse(routing.themeEditorV2.layout.page.sections, {
        pageId: currentPageId,
        sectionKey: activeSectionKey,
      }),
    )
  }

  return (
    <S.Layout
      style={{
        top: rect.top > 0 ? 0 : Math.abs(rect.top),
        left: 0,
      }}
    >
      <S.List>
        <S.ListItem onClick={redirectToSection}>
          <Icon component={PencilIcon} height={16} />
          Edit section
        </S.ListItem>
        {section?.modifiable && (
          <>
            <S.Divider />
            <S.ListItem
              onClick={() =>
                changeSectionVisibility({
                  sectionId: section.id!,
                  visible: false,
                  forceReload: false,
                })
              }
            >
              <Icon component={PreviewOffIcon} height={16} />
            </S.ListItem>
            <S.ListItem
              onClick={() => {
                duplicateSection(section.sectionKey)
              }}
            >
              <Icon component={CopyIcon} height={16} />
            </S.ListItem>
            <S.ListItem
              onClick={() => {
                removeSection(activeSectionKey)
              }}
            >
              <Icon component={TrashIcon} height={16} />
            </S.ListItem>
          </>
        )}
      </S.List>
    </S.Layout>
  )
}
